import React, { useState, useEffect } from "react";
import 'tippy.js/dist/tippy.css';
import Tooltip from '@tippyjs/react';
import "react-datepicker/dist/react-datepicker.css";
import ContentLoader from "react-content-loader";
import { ToastContainer, toast } from 'react-toastify';

import AssetList from "../../../../components/assetList";
import Helper from "../../../../Helper";
import { getTrans as t } from "../../../../Localization/translations";
import GetCompanyInfoService from "../../../../services/company/getCompanyInfoService";
import ViewAssetService from "../../../../services/contract/asset/editAssetService";


function ViewAssets({ asset_id, id, contracttype }) {

    const [asset_number, setAsset_number] = useState("");
    const [asset_desc, setAsset_desc] = useState("");
    const [license_number, setLicense_number] = useState("");
    const [financed_amount, setFinanced_amount] = useState("");
    const [year, setYear] = useState("");
    const [vin_number, setVin_number] = useState("");
    const [license_state, setLicense_state] = useState("");
    const [dealer_payable, setDealer_payable] = useState("");
    const [manufacturer, setManufacturer] = useState("");
    const [make, setMake] = useState("");
    const [model, setModel] = useState("");
    const [user_purpose, setUser_purpose] = useState("");
    const [residal_value, seTresidal_value] = useState("");
    const [reg_address, setReg_address] = useState("");
    const [vendor_name, setVendor_name] = useState("");
    const [delivery_date, setDelivery_date] = useState("");
    const [in_service_date, setIn_service_date] = useState("");
    const [milage, setMilage] = useState("");
    const [vehicle_cost, setVehicle_cost] = useState("");
    const [vehicle_cost_payto, setVehicle_cost_payto] = useState("");
    const [tax_amount, setTax_amount] = useState("");
    const [tax_amount_payto, setTax_amount_payto] = useState("");
    const [trade_in, setTrade_in] = useState("");
    const [trade_in_payto, setTrade_in_payto] = useState("");
    const [reg_cost, setReg_cost] = useState("");
    const [reg_cost_payto, setReg_cost_payto] = useState("");
    const [total_cost, setTotal_cost] = useState("");
    const [down_payment, setDown_payment] = useState("");
    const [down_payment_payto, setDown_payment_payto] = useState("");
    const [assettype, setAssetType] = useState("");
    const [loading, setLoading] = useState(true)
    const [hideshow, setHideShow] = useState(false)
    const [extrafiledcontractasset, setExtraFiled] = useState([])
    const [attribute, setAttribute] = useState([
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
        { attribute: "" },
    ])
    const [condition, setCondition] = useState("");
    const [vendor_asset_Id, setVendor_Asset_Id] = useState("");
    const [salvage_value, setSalvageValue] = useState("");
    
    const handleshowHide = () => {
        setHideShow(true)
    }

    const getExtrafiled = () => {
        GetCompanyInfoService.getExtraFiled().then(
            (response) => {
                setExtraFiled(response.data.existcontractasset)
            }
        )
    }

    useEffect(() => {
        getExtrafiled()
        ViewAssetService.getAsset(asset_id).then(
            (response) => {
                setAsset_number(response.data.asset_number)
                setAsset_desc(response.data.asset_desc)
                setLicense_number(response.data.license_number)
                setFinanced_amount(response.data.financed_amount)
                setYear(response.data.year)
                setVin_number(response.data.vin_number)
                setLicense_state(response.data.license_state)
                setDealer_payable(response.data.dealer_payable)
                setManufacturer(response.data.manufacturer)
                setMake(response.data.make)
                setModel(response.data.model)
                setAssetType(response.data.assettype)
                setUser_purpose(response.data.user_purpose)
                seTresidal_value(response.data.residal_value)
                setReg_address(response.data.address_name)
                setVendor_name(response.data.vendor)
                setDelivery_date(response.data.delivery_date)
                setIn_service_date(response.data.in_service_date)
                setMilage(response.data.milage)
                setVehicle_cost(response.data.vehicle_cost)
                setVehicle_cost_payto(response.data.vehicle_cost_payto)
                setTax_amount(response.data.tax_amount)
                setTax_amount_payto(response.data.tax_amount_payto)
                setTrade_in(response.data.trade_in)
                setTrade_in_payto(response.data.trade_in_payto)
                setReg_cost(response.data.reg_cost)
                setReg_cost_payto(response.data.reg_cost_payto)
                setTotal_cost(response.data.total_cost)
                setDown_payment(response.data.down_payment)
                setDown_payment_payto(response.data.down_payment_payto)
                setCondition(response.data.condition);
                setVendor_Asset_Id(response.data.vendorAssetId);
                setSalvageValue(response.data.salvageValue);
                setAttribute([
                    { attribute: response.data.assetattribute1 },
                    { attribute: response.data.assetattribute2 },
                    { attribute: response.data.assetattribute3 },
                    { attribute: response.data.assetattribute4 },
                    { attribute: response.data.assetattribute5 },
                    { attribute: response.data.assetattribute6 },
                    { attribute: response.data.assetattribute7 },
                    { attribute: response.data.assetattribute8 },
                    { attribute: response.data.assetattribute9 },
                    { attribute: response.data.assetattribute10 },
                    { attribute: response.data.assetattribute11 },
                    { attribute: response.data.assetattribute12 },
                    { attribute: response.data.assetattribute13 },
                    { attribute: response.data.assetattribute14 },
                    { attribute: response.data.assetattribute15 },
                ])
                setLoading(false)
            },
        )
    }, [asset_id])

    return (
        <>
            {
                hideshow === false ?
                    <div className="">
                        {
                            loading === false ? (
                                <>
                                    <div className="header">
                                        <h4 className="mb-3 pt-3 tc" onClick={handleshowHide} >{<i className="fa  fa-solid fa-arrow-left"></i>} {t("View Assets")}</h4>
                                    </div>
                                    <div className="card" role="document">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label"> {t("Asset Number")} <Tooltip content={t("AssetNo_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                <div className="col-xl-4 d-flex">
                                                    <p className=" view-label p " >
                                                        {asset_number}
                                                    </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className="col-form-label">
                                                        {t("Asset Description")} <Tooltip content={t("AssetDesc_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                                                    </label>
                                                <div className="col-xl-4 d-flex">
                                                    <p className=" view-label p " >
                                                        {asset_desc ? asset_desc : ""}
                                                    </p>
                                                    </div>
                                                </div>

                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label"> {t("License Number")} <Tooltip content={t("LicenseNo_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                <div className="col-xl-4 d-flex">
                                                    <p className=" view-label p " >
                                                        {license_number ? license_number : ""}
                                                    </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">
                                                        {t("Year")} <Tooltip content={t("Year_Tooltip")} ><i className="fa fa-light fa-circle-info"></i></Tooltip>
                                                    </label>
                                                <div className="col-xl-4 d-flex">
                                                    <p className=" view-label p " >
                                                        {year ? year : ""}
                                                    </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label"> {t("VIN Number")} <Tooltip content={t("VINNumber_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">

                                                    <p className=" view-label p " >
                                                        {vin_number ? vin_number : ""}
                                                    </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("License State")} <Tooltip content={t("LicenseState_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                <div className="col-xl-4 d-flex">
                                                    <p className=" view-label p " >
                                                        {license_state ? license_state : ""}
                                                    </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Manufacturer")} <Tooltip content={t("Manufacturer_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                <div className="col-xl-4 d-flex">
                                                    <p className=" view-label p " >
                                                        {manufacturer ? manufacturer : ""}
                                                    </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Make")} <Tooltip content={t("Make_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                <div className="col-xl-4 d-flex">
                                                    <p className=" view-label p " >
                                                        {make ? make : ""}
                                                    </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Model")} <Tooltip content={t("Model_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                <div className="col-xl-4 d-flex">
                                                    <p className=" view-label p " >
                                                        {model ? model : ""}
                                                    </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-4 d-flex">
                                                    <label className="col-form-label">{t("Residual Value")} <Tooltip content={t("ResidalValue_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                    <p className="view-label p " >
                                                        {Helper.Amount(residal_value)}
                                                    </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Financed Amount")} <Tooltip content={t("FinancedAmount_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                    <p className=" view-label p " >
                                                        {Helper.Amount(financed_amount)}
                                                    </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Dealer Payable")} <Tooltip content={t("DealerPayable_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                    <p className=" view-label p " >
                                                        {Helper.Amount(dealer_payable)}
                                                    </p>
                                                </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Asset Type")} <Tooltip content={t("Assettype_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                    <p className=" view-label p " >
                                                        {assettype ? assettype : ""}
                                                    </p>
                                                    </div> 
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className="col-form-label">{t("Condition")} <Tooltip content={t("Condition_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className="view-label p " >
                                                            {condition ? condition : ""}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="col-xl-4 d-flex">
                                                    <label className="col-form-label">{t("VendorAsset ID")} <Tooltip content={t("VendorAssetID_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className="view-label p " >
                                                            {vendor_asset_Id ? vendor_asset_Id : ""}
                                                        </p>
                                                    </div>
                                                </div>
                                              
                                              {
                                                contracttype !== "Loan" ?  
                                                <div className="col-xl-4 d-flex" style={{ display: contracttype === "Loan" ? "none" : true }} >
                                                    <label className="col-form-label">{t("Salvage Value")} <Tooltip content={t("Salvagevalue_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className="view-label p " >
                                                            {salvage_value ? salvage_value : ""}
                                                        </p>
                                                    </div>
                                                </div>
                                                :
                                                ""
                                              }
                                            </div>


                                            <h4 className="card-title pt-2">{t("Installation Details")} </h4>
                                            <div className="row">
                                            <div className="col-xl-5 d-flex">
                                                <label className=" col-form-label">{t("Install At")} <Tooltip content={t("InstallAddress_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                <div className="col-xl-6 d-flex">
                                                    <p className=" view-label p " >
                                                        {reg_address.address_line_1}, {`${reg_address.address_line_2 !== "" ? reg_address.address_line_2 + ", " : ""}`}{reg_address.city}, {reg_address.state}, {reg_address.country}
                                                    </p>
                                                </div>
                                            </div>
                                            </div>
                                            <h4 className="card-title pt-2">{t("Supplier Details")}</h4>
                                            <div className="row">
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Vendor Name")} <Tooltip content={t("VendorName_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className=" view-label p " >
                                                            {vendor_name}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Delivery Date")} <Tooltip content={t("DeliveryDate_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className="view-label p " >
                                                            {delivery_date ? Helper.DateNormal(delivery_date) : ""}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("In-Service Date")} <Tooltip content={t("In-ServiceDate_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className=" view-label p " >
                                                            {in_service_date ? Helper.DateNormal(in_service_date) : ""}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Mileage")} <Tooltip content={t("Mileage")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className=" view-label p " >
                                                            {Helper.Amount(milage)}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Vehicle Cost")} <Tooltip content={t("VehicleCost_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className=" view-label p " >
                                                            {Helper.Amount(vehicle_cost)}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Vehicle Cost (Pay To)")} <Tooltip content={t("VehicleCost(Pay To)_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className="view-label p " >
                                                            {vehicle_cost_payto}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Tax (%)")} <Tooltip content={t("Tax_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className=" view-label p " >
                                                            {Helper.Amount(tax_amount)}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Tax Amount (Pay To)")} <Tooltip content={t("TaxAmount(Pay To)_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className=" view-label p " >
                                                            {tax_amount_payto}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Trade In")} <Tooltip content={t("TradeIn_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                    <p className=" view-label p " >
                                                        {Helper.Amount(trade_in)}
                                                    </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Trade In (Pay To)")} <Tooltip content={t("TradeIn(Pay To)_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className=" view-label p " >
                                                            {trade_in_payto}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Registration Cost")} <Tooltip content={t("RegistrationCost_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className=" view-label p " >
                                                            {Helper.Amount(reg_cost)}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Registration Cost (Pay To)")}
                                                        <Tooltip content={t("RegistrationCost(Pay To)_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip>
                                                    </label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className=" view-label p " >
                                                            {reg_cost_payto}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-4 d-flex">
                                                    <label className="  col-form-label">{t("Total Cost")} <Tooltip content={t("TotalCost_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className=" view-label p " >
                                                            {Helper.Amount(total_cost)}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Down Payment")} <Tooltip content={t("DownPayment_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className=" view-label p" >
                                                            {Helper.Amount(down_payment)}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 d-flex">
                                                    <label className=" col-form-label">{t("Down Payment (Pay To)")} <Tooltip content={t("DownPayment(Pay To)_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                                                    <div className="col-xl-4 d-flex">
                                                        <p className=" view-label p " >
                                                            {down_payment_payto}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                {
                                                    extrafiledcontractasset.map((key, index) => (
                                                        <>
                                                            <div className="col-xl-4 d-flex" style={{ display: key.enable === 'True' ? true : "none" }}>
                                                                    <label className="col-form-label" style={{ display: key.enable === 'True' ? true : "none" }}>{key.label} </label>
                                                                <div className="col-xl-4 d-flex" style={{ display: key.enable === 'True' ? true : "none" }}>
                                                                    <p className="view-label p " style={{ display: key.enable === 'True' ? true : "none" }}>
                                                                        {attribute[index]['attribute'] ? attribute[index]['attribute'] : ""}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <ContentLoader
                                    viewBox="0 0 400 160"
                                    backgroundColor="rgba(0,0,0,0.06)"
                                    foregroundColor="rgba(0,0,0,0.12)"
                                >
                                    <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
                                    <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
                                    <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
                                    <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
                                    <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
                                    <rect x="0" y="99" rx="5" ry="5" width="400" height="200" />
                                </ContentLoader>
                            )
                        }
                    </div> :
                    <AssetList id={id} contracttype={contracttype} />
            }
        </>
    )
}

export default ViewAssets